// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"af89c869","513":"24e3a9e2","703":"317f398c"}[chunkId] + ".chunk.js";
};